import { render, staticRenderFns } from "./ModuleModeForm.vue?vue&type=template&id=389e205c"
import script from "./ModuleModeForm.vue?vue&type=script&lang=js"
export * from "./ModuleModeForm.vue?vue&type=script&lang=js"
import style0 from "./ModuleModeForm.vue?vue&type=style&index=0&id=389e205c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports